import { render } from "./PromoCategories.vue?vue&type=template&id=31babb22&scoped=true&ts=true"
import script from "./PromoCategories.vue?vue&type=script&lang=ts"
export * from "./PromoCategories.vue?vue&type=script&lang=ts"

import "./PromoCategories.vue?vue&type=style&index=0&id=31babb22&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31babb22"]])

export default __exports__